export enum IUploadFileType {
  PDF = "PDF",
  IMAGE = "IMAGE",
  CAMERA = "CAMERA",
}